import React, { Fragment } from "react"
import styled from "styled-components"
import {
  fetchData,
  removeData,
  showToast,
  setHeaderTitle,
  saveData,
  showPopup,
  hidePopup,
} from "../../store/action"
import PageHeader from "../PageHeader"
import { Card } from "../../components/horizontalScroll/Card"
import { trendingBids } from "../../dummyData"
import { withRouter } from "react-router"
import { connect } from "react-redux"
import { translate } from "react-i18next"
import { replaceWithSymbol } from "../../util/cutString"
import { secondsToHms } from "../../util/Utility"
const InnerWrapper = styled.div`
  width: 100%;
  background-color: #1c1d23;
  min-height: calc(100vh - 56px);
  padding: 20px;
  box-sizing: border-box;
`

class DailyBids extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      mainLoader: true,
    }
  }

  loadData() {
    console.log("offers DAILY  Auctions load data")
    const { fetchData, uniqueId, saveData } = this.props
    fetchData({
      uniqueId,

      method: "GET",
      uri: `/offers`,
      onSuccess: (res) => {
        console.log(res.auctionDetailsDTO.auction)
        if (res && res.auctionDetailsDTO && res.auctionDetailsDTO.auction) {
          this.setState({
            mainLoader: false,
            bids: res.auctionDetailsDTO.auction,
          })
        } else {
          this.setState({ mainLoader: false, bids: [] })
        }
      },
    })
  }

  bidClickHanlder(offerTitle, offerId) {
    this.props.history.push(
      `/play/product-details/${replaceWithSymbol(offerTitle)}/${offerId}`
    )
  }

  componentDidMount() {
    this.loadData()
  }

  render = () => {
    const { bids, mainLoader } = this.state
    //  if(mainLoader){
    //    return null;
    //  }
    // console.log({bids})
    return (
      <Fragment>
        {/* <div className='wrapper'> */}
        <PageHeader backLocation={"/play/all-bids/"} label={"Daily Bids"} />
        <div>
          <InnerWrapper>
            {bids &&
              bids.length > 0 &&
              bids.map((item) => {
                const {
                  offerId,
                  id,
                  offerTitle,
                  title,
                  offerImageUrl,
                  src,
                  offerTimeLeft,
                  timeLeft,
                  alt,
                  isActiveOffer,
                } = item
                const convertedTimeLeft = secondsToHms(offerTimeLeft)

                if (item.isDaily) {
                  console.log("ITEM ", item.isDaily)
                  return (
                    <div
                      key={offerId ? offerId : id}
                      style={{ margin: "20px 0" }}
                    >
                      <Card
                        title={offerTitle ? offerTitle : title}
                        itemId={offerId ? offerId : id} // NOTE: itemId is required for track items
                        key={offerId ? offerId : id}
                        src={offerImageUrl ? offerImageUrl : src}
                        time={offerTimeLeft ? offerTimeLeft : timeLeft}
                        alt={alt ? alt : "Alt text not available"}
                        scrollTitleColor='rgb(121, 212, 255)'
                        onClick={() =>
                          isActiveOffer === "true"
                            ? this.bidClickHanlder(offerTitle, offerId)
                            : null
                        }
                        isActiveOffer={isActiveOffer}
                      />
                    </div>
                  )
                }
              })}
            {!bids && <strong>No Data Found!</strong>}
          </InnerWrapper>
        </div>
        {/*  </div> */}
      </Fragment>
    )
  }
}

DailyBids = connect(
  (state, ownProps) => {
    let mapStateToProps = {}
    if (state.data && state.data[ownProps.uniqueId]) {
      mapStateToProps.data = state.data[ownProps.uniqueId]
    }
    return mapStateToProps
  },
  {
    fetchData,
    removeData,
    showToast,
    setHeaderTitle,
    saveData,
    showPopup,
    hidePopup,
  }
)(withRouter(translate("translations")(DailyBids)))
export default DailyBids



// WEBPACK FOOTER //
// ./src/views/DailyBids/index.js